import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKitsuComponent } from './simple-icons-kitsu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKitsuComponent ],
    exports:      [ SimpleIconsKitsuComponent ],
    bootstrap:    []
})
export class SimpleIconsKitsuModule {}
